<ng-container *ngIf="PreviewListTracking.length>0;else default">

  <div class="d-flex flex-column flex-sm-row pb-3" >
    <div class="d-flex flex-sm-column flex-sm-grow-1">
      <div class="d-flex flex-sm-row flex-column">
        <span class="tracking-subheader pr-1 ">
          {{('p.track.result.title'|translate)|ketranslate: PreviewListTracking.length}}


        </span>
        <span class="tracking-subheader-14 d-sm-none d-block" *ngIf="ExceedLimit" style="color: #999999;">(
          {{('g.exceed.search'|translate)|ketranslate:_TrackingService.ListTracking_notfound}}
          )</span>
        <span class="tracking-subheader  ke-color-primary ke-color-primary_cool" *ngIf="_TrackingService.ListTracking_notfound>0">(
          {{('p.track.not-found'|translate)|ketranslate:_TrackingService.ListTracking_notfound}}
          )</span>
      </div>
      <span class="tracking-subheader-14  d-sm-block d-none" *ngIf="ExceedLimit" style="color: #999999;">(
        {{('g.exceed.search'|translate)|ketranslate:_TrackingService.ListTracking_notfound}}
        )</span>
    </div>

    <div class="d-flex">

      <input #actionkey hidden value="''">
      <input #activefilterkey hidden value="g.filter.all">
      <button class="{{actionkey.value!='filter'?'ke-btn-outline':'ke-btn-primary'}} d-flex align-items-center"
        style="padding: 3px 20px; " #originfilter type="button"
        (click)="actionkey.value=('filter');ShowTemplate(filtermenu, originfilter,actionkey)">
        <img *ngIf="actionkey.value!='filter'" class="image-filter"  width="20">
        <img *ngIf="actionkey.value=='filter'" class="image-filter_w"  width="20">
         
        <span class="pl-1 ke-font-button">{{'p.track.btn.filter'|translate}}</span>
      </button>

      <ng-template #filtermenu>
        <div class="d-flex flex-column">
          <span class="menu" style=" margin-left: 30px;"></span>
          <div class="mat-menu-panel">
            <div class="mat-menu-content">
              <button *ngFor="let key of ListFilterKey" mat-menu-item
                [class]="(activefilterkey.value == key.display_key)?'filter-active':''"
                (click)="activefilterkey.value=key.display_key;Filter(key);CloseTemplate(filtermenu)">
                <span> {{key.display_key|translate}}</span>
              </button>
            </div>
          </div>
        </div>
      </ng-template>
      <button class="{{actionkey.value!='share'?'ke-btn-outline':'ke-btn-primary'}} ml-3 d-flex align-items-center"
              style="padding: 3px 20px; " #originshare type="button"
              (click)="actionkey.value=('share');loadingShareLink=0;loadingShareImg=0;ShowTemplate(sharemenu, originshare,actionkey);">
        <img *ngIf="actionkey.value!='share'" class="image-share" width="20">
        <img *ngIf="actionkey.value=='share'" class="image-share_w" width="20">
        <span class="pl-1 ke-font-button">{{'p.track.btn.share'|translate}}</span>
      </button>


      <ng-template #copyurltemplate let-close="close">
        <div class="d-flex flex-column">
          <span class="menu" style="margin-left: 30px;"></span>
          <div class="mat-menu-panel p-2" style=" overflow: hidden;">
            <mat-form-field style="margin-bottom: -20px;">
              <mat-label>{{'g.your-url'|translate}}</mat-label>
              <input matInput type="text" value="{{public_url.shortUrl}}"
                onClick="this.setSelectionRange(0, this.value.length)">
              <button mat-button matSuffix mat-icon-button matTooltip="{{'g.copy-url'|translate}}"
                [cdkCopyToClipboard]="public_url.shortUrl" matTooltipClass="ke-background-primary">
                <mat-icon>content_copy</mat-icon>
              </button>
            </mat-form-field>
          </div>

        </div>
      </ng-template>

      <ng-template #sharemenu let-close="close">
        <div class="d-flex flex-column">
          <span class="menu" style="margin-left: 30px;"></span>
          <div class="mat-menu-panel">
            <div class="mat-menu-content">
              <button mat-menu-item (click)="generate_public_url(copyurltemplate, originshare,actionkey);">
                <span>{{'g.copy-url'|translate}}</span>
              </button>
              <mat-progress-bar *ngIf="loadingShareLink==1" mode="query"></mat-progress-bar>

              <button mat-menu-item (click)="ShareImage(1);loadingShareImg=1;">
                <span>{{'g.share.image'|translate}}</span>
              </button>
              <mat-progress-bar *ngIf="loadingShareImg==1" mode="query"></mat-progress-bar>
            </div>
          </div>
        </div>
      </ng-template>

      <mat-menu hidden>

      </mat-menu>

    </div>

  </div>


  <div class="d-flex flex-column" #resultpanel>

    <ng-container *ngIf="Onloading;else preview">
      <ng-container *ngFor="let tracking of PreviewListTracking;">
        <div class="mb-3">
          <div class="d-flex flex-column flex-sm-row p-3" style="background-color: white;">

            <ngx-content-loading speed="3000ms" [width]="1000" style="width: 100%;" [height]="120"
              [primaryColor]="'#F5F5F5'" [secondaryColor]="'#d9d9d9'">
              <svg:g ngx-circle cy="50" cx="50" r="50" rx="5" ry="5"></svg:g>
              <svg:g ngx-rect width="400" height="20" y="0" x="150" rx="5" ry="5"></svg:g>

              <svg:g ngx-rect width="150" height="20" y="0" x="850" rx="5" ry="5"></svg:g>
              <svg:g ngx-rect width="500" height="20" y="30" x="150" rx="5" ry="5"></svg:g>

              <svg:g ngx-rect width="880" height="40" y="60" x="150" rx="5" ry="5"></svg:g>
            </ngx-content-loading>
          </div>

        </div>

      </ng-container>


    </ng-container>
    <ng-template #preview>
      <ng-container *ngFor="let tracking of PreviewListTracking;let idx=index">
        <kett-tracking-item [hidden]="tracking.hidden" [tracking_data]="tracking" [info]="tracking.ref"
          [IsNotFound]="!tracking.isfound" [index]="idx" class="mb-3" [showdetail]="tracking.showdetail" [kcIcon]="tracking.ref?.shipment?.cool_con_type!=''&&tracking.ref?.shipment?.cool_con_type!=unified?'_KC':''"
          (ChangeShowDetail)="ChangeDetail($event, tracking.ref?.shipment)" [xx1]="isCool">
        </kett-tracking-item>
      </ng-container>

    </ng-template>



  </div>

</ng-container>

<ng-template #default>
  <kett-tracking-start *ngIf="LoadedQR"></kett-tracking-start>
</ng-template>
